import { get, post } from './index';

import { IConnection } from 'models/connection';
import { IOAuthCodeChangePayload } from 'models/payloads/oAuth';

export const getOAuthUrl = () => get<{ url: string }>('/oauth', true);
export const exchangeOAuthCode = (payload: IOAuthCodeChangePayload) => post<IOAuthCodeChangePayload, IConnection>('/oauth', payload, true);
